module.exports = __webpack_public_path__ + "img/1F1E8-1F1FA.f0c0962c.svg";